export default "__VITE_ASSET__HtZyNaFG__"